export const usePushNotifications = (_: boolean) => {
};
